export default {
	allTeamsDropDownOption: "My teams and 1:1s",

	unexpectedError: "Unexpected error: {message}",
	selectTeamErrorNotification: "Error selecting team: {message}",
	selectGoalTypeErrorNotification: "Error getting goals: {message}",
	pageGoalsErrorNotification: "Error getting goals: {message}",
};
